import { Component, Input } from '@angular/core'
import { Icon, IconComponent } from '../icon'

@Component({
  selector: 'ftr-empty-state',
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.css'],
  standalone: true,
  imports: [IconComponent],
})
/**
 * A component to display when a section is empty
 */
export class EmptyStateComponent {
  @Input() icon: Icon
}
